import React from 'react';
import { Batiment } from '../../../../shared/types/game';

interface BuildingLitsTabProps {
  building: Batiment;
}

const BuildingLitsTab: React.FC<BuildingLitsTabProps> = ({ building }) => {
  const totalChambres = building.capacite || 0;
  const chambresOccupees = building.postes_occupes || 0;
  const chambresDisponibles = building.postes_disponibles || 0;
  const PLACES_PAR_CHAMBRE = 2; // 2 lits par chambre

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-white">Chambres ({totalChambres})</h3>
        <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors">
          + Ajouter une chambre
        </button>
      </div>

      {/* Statistiques */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="bg-zinc-800 rounded-lg p-4 border border-zinc-700">
          <p className="text-2xl font-bold text-white">{totalChambres}</p>
          <p className="text-sm text-zinc-400 mt-1">Total</p>
        </div>
        <div className="bg-zinc-800 rounded-lg p-4 border border-zinc-700">
          <p className="text-2xl font-bold text-white">{chambresOccupees}</p>
          <p className="text-sm text-zinc-400 mt-1">Occupées</p>
        </div>
        <div className="bg-zinc-800 rounded-lg p-4 border border-zinc-700">
          <p className="text-2xl font-bold text-white">{chambresDisponibles}</p>
          <p className="text-sm text-zinc-400 mt-1">Disponibles</p>
        </div>
      </div>

      {/* Liste des chambres */}
      {totalChambres === 0 ? (
        <div className="text-center py-12 text-zinc-400">
          <p className="text-lg mb-2">Aucune chambre disponible</p>
          <p className="text-sm">Les chambres seront créées automatiquement avec les augmentations de capacité</p>
        </div>
      ) : (
        <div className="space-y-3">
          {Array.from({ length: totalChambres }, (_, index) => {
            const chambreNumero = index + 1;
            const isOccupee = index < chambresOccupees;
            
            return (
              <div
                key={chambreNumero}
                className={`bg-zinc-800 border rounded-lg p-4 transition-colors ${
                  isOccupee
                    ? 'border-red-500/50 hover:border-red-500'
                    : 'border-zinc-700 hover:border-sky-500'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h4 className="text-lg font-semibold text-white">
                      Chambre #{chambreNumero}
                    </h4>
                    <div className="flex items-center gap-3 mt-2">
                      <span className={`px-2 py-1 rounded text-xs ${
                        isOccupee
                          ? 'bg-red-500/20 text-red-400'
                          : 'bg-green-500/20 text-green-400'
                      }`}>
                        {isOccupee ? 'Occupée' : 'Disponible'}
                      </span>
                      <span className="text-xs text-zinc-400">
                        Capacité: {PLACES_PAR_CHAMBRE} lits
                      </span>
                    </div>
                  </div>
                  <button className="ml-4 text-zinc-400 hover:text-white transition-colors">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                    </svg>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BuildingLitsTab;


